import { lazy } from 'react';

const SupportTickets = lazy(() => import('./SupportTickets'));

export default SupportTickets;
